import { lazy } from 'react';

import { ALLOWED_ROLES, REMOTE_CONFIG_KEYS, withRemoteConfigKey } from 'packages/utils';

import AbsencesWrapper from './components/AbsencesWrapper';
import { PATHS } from './constants';

const AbsencesList = lazy(() => import('./screens/AbsencesList'));

const routes = [
  {
    component: props => <AbsencesWrapper component={AbsencesList} routeProps={props} />,
    path: PATHS.BASE_URL,
    exact: true,
    allowedRoles: ALLOWED_ROLES.ORGANIZATIONS.ABSENCES.LIST,
    onOrgChangeRedirectTo: `/:orgId/-/${PATHS.BASE_URL}`,
  },
];

export default withRemoteConfigKey(REMOTE_CONFIG_KEYS.TIME_TRACKER, routes);
